/** Matches http/https URLs (same intent as iOS NSDataDetector / web waveLinkify). */
export const WAVE_HTTP_URL_REGEX = /https?:\/\/[^\s<>"')\]}]+/gi;
export function waveTextContainsHttpLink(text) {
    if (!text)
        return false;
    WAVE_HTTP_URL_REGEX.lastIndex = 0;
    return WAVE_HTTP_URL_REGEX.test(text);
}
/** Stale block snapshot: local draft is ahead of materialized `external` (common on fast blur). */
export function isStaleExternalBehindLocalDraft(external, draft) {
    return draft !== external && draft.length > external.length && draft.startsWith(external);
}
/**
 * Pure sync reducer for Wave plain-text fields (web DraftTextField / iOS WavePlainTextField).
 * Presentation (linkified display) must never gate this decision.
 */
export function decideTextFieldSync(input) {
    const { external, draft, isEditing, isFocused = true, allowRemoteOverwrite, remoteRevisionBumped, } = input;
    const activelyEditing = isEditing && isFocused;
    if (external === draft) {
        return { nextDraft: draft, shouldSync: false };
    }
    if (isStaleExternalBehindLocalDraft(external, draft) && !allowRemoteOverwrite) {
        return { nextDraft: draft, shouldSync: false };
    }
    const shouldSync = (remoteRevisionBumped && (!activelyEditing || allowRemoteOverwrite)) ||
        ((!activelyEditing || allowRemoteOverwrite) && external !== draft);
    if (shouldSync) {
        return { nextDraft: external, shouldSync: true };
    }
    return { nextDraft: draft, shouldSync: false };
}
/** True when the field should show linkified read-only display instead of the native editor. */
export function shouldShowLinkifiedDisplay(isDisplayEditing, draft) {
    return !isDisplayEditing && draft.length > 0 && waveTextContainsHttpLink(draft);
}
